/** Name of the hidden field carrying the form's Sanity "Form ID" on submit;
 *  the send-form route reads it to resolve the form title. */
export const FORM_ID_FIELD = '_formId';

export type FormDto = {
    id: string;
    title?: string;
    fields?: FormFieldDto[];
    submitButton?: {
        text?: string;
    };
};

/** A choice of a select, radio or checkbox field. Icon and second line are the
 *  Studio's additions (`withFormChoiceFields`), shown on the tiles of checkbox
 *  and radio groups. */
export type FormChoiceDto = {
    _key?: string;
    label?: string;
    value?: string;
    /** A UiIcon name. */
    icon?: string;
    /** Second line of the tile, e.g. „ab 149 €“. */
    description?: string;
};

/** Only the fields the privacy link needs; the block fragments project just these. */
export type PrivacyPolicyLink = { slug?: string; title?: string };

export type FormFieldDto = {
    _key?: string;
    label?: string;
    name?: string;
    required?: boolean;
    type?:
        | 'checkbox'
        | 'color'
        | 'date'
        | 'datetime-local'
        | 'email'
        | 'file'
        | 'hidden'
        | 'number'
        | 'radio'
        | 'range'
        | 'select'
        | 'tel'
        | 'text'
        | 'textarea'
        | 'time'
        | 'url';
    validation?: {
        type?: string;
        value?: string;
        message?: string;
    }[];
    choices?: FormChoiceDto[];
    options?: {
        placeholder?: string;
        defaultValue?: string;
    };
};
